/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import { AhaIcon, type AhaIconProps } from '../canvasx/AhaIcon';
import { FaIcon, type FaIconProps } from '../canvasx/FaIcon';

const Epic: CanvaSXFC<AhaIconProps> = props => (
  <AhaIcon {...props} icon='epic-solid' />
);
const Feature: CanvaSXFC<FaIconProps> = props => (
  <FaIcon {...props} style='solid' icon='grid-2' />
);
const Idea: CanvaSXFC<FaIconProps> = props => (
  <FaIcon {...props} style='solid' icon='lightbulb' />
);
const Initiative: CanvaSXFC<FaIconProps> = props => (
  <FaIcon {...props} style='solid' icon='sitemap' />
);
const Release: CanvaSXFC<FaIconProps> = props => (
  <FaIcon {...props} style='solid' icon='calendar-lines' />
);
const ReleasePhase: CanvaSXFC<FaIconProps> = props => (
  <FaIcon {...props} style='solid' icon='timeline' />
);
const Requirement: CanvaSXFC<FaIconProps> = props => (
  <FaIcon {...props} style='solid' icon='list' />
);
const Goal: CanvaSXFC<FaIconProps> = props => (
  <FaIcon {...props} style='solid' icon='flag' />
);
const Task: CanvaSXFC<FaIconProps> = props => (
  <FaIcon {...props} style='solid' icon='check' />
);
const KeyResult: CanvaSXFC<FaIconProps> = props => (
  <FaIcon {...props} style='solid' icon='arrow-trend-up' />
);
const IdeaTheme: CanvaSXFC<FaIconProps> = props => (
  <FaIcon {...props} style='solid' icon='circle-nodes' />
);
const Project: CanvaSXFC<FaIconProps> = props => (
  <FaIcon {...props} style='solid' icon='browser' />
);

export const RecordIcons: Record<string, CanvaSXComponent> = {
  Epic,
  Feature,
  Goal,
  Idea,
  IdeaTheme,
  Initiative,
  Release,
  ReleasePhase,
  Requirement,
  Task,
  KeyResult,
  Project,
};
